import React, { useContext, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Chip,
  Autocomplete,
  IconButton,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router";
import { AuthContext } from "../../contexts/AuthContext";
import { fieldsOfStudy } from "../../constants/FieldsOfStudy";

const SignUpWriter = () => {
  const{setUser}=useContext(AuthContext)
  const[email,setEmail]=useState("")
  const[password,setPassword]=useState("")
  const[phoneNumber,setPhoneNumber]=useState("")
  const[yearsOfExperience,setYearsOfExperience]=useState(0)
  const [expertise, setExpertise] = useState("");
  const [expertiseList, setExpertiseList] = useState([]);
  const[loading,setLoading]=useState(false)
  const [availableOptions] = useState(fieldsOfStudy);
  const [showPassword, setShowPassword] = useState(false);
 const navigate=useNavigate()
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleAddExpertise = (event) => {
    if (
      event.key === "Enter" &&
      expertise.trim() &&
      !expertiseList.includes(expertise)
    ) {
      setExpertiseList([...expertiseList, expertise.trim()]);
      setExpertise("");
    }
  };

  const handleDeleteExpertise = (item) => {
    setExpertiseList(expertiseList.filter((exp) => exp !== item));
  };
  const createAccount=async()=>{
    setLoading(true)
    try{
      const response=await axios.post(`${process.env.REACT_APP_WRITER_SIGN_UP}`,{email,password,phoneNumber,yearsOfExperience,writingExpertise:expertiseList},{withCredentials:true})
      if(response.data.success){
        toast.success("Account Created Succesfully!")
        setUser(response.data.writer)
        setTimeout(()=>{
          navigate("/writer/dashboard")
        })
      }
      else{
        toast.error(response.data.message)
      }
    }
    catch(e){
      toast.error(e.response?e.response.data.message:e.message)
      
    }
    finally{
      setLoading(false)
    }
  }

  return (
    <Box
      sx={{
        minHeight: {xs:"100%",md:"90%"},
        mt:-2,
        backgroundColor: "#F5F5F5",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: 0,
      }}
    >
      <ToastContainer/>
      <Box
        sx={{
          width: { xs: "95%", sm: "90%", md: "85%" },
          backgroundColor: "white",
          borderRadius: 3,
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
          padding: 2,
          display: "flex",
          flexDirection: "column",
          gap: 4,
          marginTop: "50px",
          transform: "translateY(-30px)",
        }}
      >
        <Typography
          variant="h5"
          fontWeight="bold"
          align="center"
          sx={{ color: "black" }}
        >
          Create Your Writer Account
        </Typography>
        <Typography
          variant="body2"
          align="center"
          sx={{ color: "black", opacity: 0.7 }}
        >
          Connect, Collaborate And Stay Organized.
        </Typography>

        {/* Input Fields */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{ color: "black" }}
            >
              Email:<span style={{ color: "red" }}> *</span>
            </Typography>
            <TextField
            onChange={(e)=>{
              setEmail(e.target.value)
            }}
              fullWidth
              variant="outlined"
              placeholder="Enter Email"
              sx={{ marginTop: 1 }}
              InputProps={{
                sx: { height: 40 },
              }}
            />
          </Box>
          <Box sx={{ flex: 1,mt:1 }}>
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{ color: "black" }}
            >
              Password:<span style={{ color: "red" }}> *</span>
            </Typography>
            <TextField
            onChange={(e)=>{
              setPassword(e.target.value)
            }}
              fullWidth
              variant="outlined"
              type={showPassword ? "text" : "password"}
              placeholder="Enter Password"
              InputProps={{
                sx: { height: 40 },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleTogglePasswordVisibility}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>

        {/* Phone Number Field */}
        <Box>
          <Typography
            variant="body2"
            fontWeight="bold"
            sx={{ color: "black" }}
          >
            Phone Number:<span style={{ color: "red" }}> *</span>
          </Typography>
          <TextField
          onChange={(e)=>{
            setPhoneNumber(e.target.value)
          }}
            fullWidth
            variant="outlined"
            placeholder="Enter Phone Number"
            sx={{ marginTop: 1 }}
            InputProps={{
              sx: { height: 40 },
            }}
          />
        </Box>

        {/* Expertise and Experience */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{ color: "black" }}
            >
              Writing Expertise:<span style={{ color: "red" }}> *</span>
            </Typography>
            <Autocomplete
              freeSolo
              options={availableOptions}
              inputValue={expertise}
              onInputChange={(event, newInputValue) =>
                setExpertise(newInputValue)
              }
              onKeyDown={handleAddExpertise}
              sx={{
                marginTop: 1,
                "& .MuiOutlinedInput-root": {
                  height: "40px",
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Type expertise and press Enter"
                />
              )}
            />
            <Box
              sx={{
                marginTop: 2,
                display: "flex",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              {expertiseList.map((item, index) => (
                <Chip
                  key={index}
                  label={item}
                  onDelete={() => handleDeleteExpertise(item)}
                  sx={{ backgroundColor: "#f0f0f0", borderRadius: 1 }}
                />
              ))}
            </Box>
          </Box>
          <Box sx={{ width: "25%" }}>
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{ color: "black" }}
            >
              Years Of Experience:<span style={{ color: "red" }}> *</span>
            </Typography>
            <TextField
            onChange={(e)=>{
              setYearsOfExperience(e.target.value)
            }}
              type="number"
              variant="outlined"
              placeholder="Years"
              fullWidth
              sx={{ marginTop: 1, height: 40 }}
              inputProps={{ style: { height: 10 } }}
            />
          </Box>
        </Box>

        {/* Portfolio */}
        <Box>
          <Typography
            variant="body2"
            fontWeight="bold"
            sx={{ color: "black" }}
          >
            Portfolio<span style={{ color: "red" }}> *</span>
          </Typography>
          <Typography
            variant="caption"
            sx={{ display: "block", marginTop: 1, color: "gray" }}
          >
            Upload portfolio or work samples:
          </Typography>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#376E70",
              color: "white",
              ":hover": { backgroundColor: "#2D5656" },
              marginTop: 1,
              width: { xs: "50%", md: "17%" },
            }}
          >
            Browse Files
          </Button>
        </Box>

        {/* Sign Up Button */}
        <Button
         onClick={createAccount}
         disabled={loading}
          variant="contained"
          sx={{
            width: { xs: "90%", md: "50%" },
            backgroundColor: "#2D5656",
            color: "white",
            padding: "8px 16px",
            ":hover": { backgroundColor: "#1C3E3E" },
            alignSelf: "center",
          }}
        >
        {loading?<CircularProgress sx={{height:"15px",width:"15px",color:'white'}} thickness={10}/>:"Sign UP"}
        </Button>
      </Box>
    </Box>
  );
};

export default SignUpWriter;
